import React, { useEffect, useState } from "react"
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import { DataService } from "./services/data-service";
import { IUserStore } from "./redux/user/types";
import { useDispatch } from "react-redux";
import { LoginUser } from "./redux/user/userReducer";
import { Protected } from "./Protected";
// import LoginPage from "./auth-pages/Login";
import { getUserToken } from "./helpers/user-token";
import { CircularProgress } from "@mui/material";
import Loader from "./components/Loader";
import BaseLayout from "./layouts/BaseLayout";
import LoginPage from "./pages/auth-pages/Login";

interface IUserDetailsResponse {
    Id: string;
    username: string;
    role: number;
}

export const Portal: React.FC = () => {

    const [loaded, setLoaded] = useState<boolean>(false);
    const dispatch = useDispatch();

    useEffect(() => {
        DataService.get("api/user/details").then(async (res) => {
            if (res.status === 200) {
                const result: IUserDetailsResponse = await res.json();
                var newStore: IUserStore = {
                    token: getUserToken() || '',
                    role: result.role.toString(),
                    isAuthenticated: true,
                    user: {
                        username: result.username,
                        Id: result.Id,
                        role: result.role,
                    },
                    active: true
                };
                dispatch(LoginUser(newStore));
                setLoaded(true);
            } else {
                // (window.location as any).href = "/login";
                setLoaded(true);

            }
        }).catch(() => {
            setLoaded(true);
        });
    }, []);

    return loaded ? <Routes>
        <Route path="login" element={<BaseLayout children={<LoginPage />} />} />
        <Route path="*" element={<Protected />} />
    </Routes> : <Loader size={75} />
}